export default {
  en: {
    common: {
      suzuka: 'Suzuka Hisamatsu',
      wolke: 'Gallery Wolke',
    },
    home: {
      videoinfo: 'You can watch a video of the event',
      worksinfo: 'You can see the exhibited works',
      aboutinfo: 'Exhibition details and about Suzuka Hisamatsu',
      videobtn: 'Watch',
      worksbtn: 'View works',
      aboutbtn: 'View details',
      contact: 'Contact',
    },
    info: {
      history: {
        1: { year: '1990', item: 'Born in Tokyo' },
        2: { year: '2013', item: 'Enter Joshibi University of Art and Design' },
        3: { year: '2015', item: 'Study abroad at the University of Applied Arts Vienna' },
        4: { year: '2016', item: 'Shanghai Jiao Tong University Summer Program, Design Competition 3rd (Shanghai, China)' },
        5: { year: '', item: 'Keiichi Tahara, Kogosei Project in Joshibi (Japan)' },
        6: { year: '2017', item: "Exchange Exhibition Brera Art Academy and Joshibi University (L'ex Chiesa San Carpotoro in Milano/Italy)" },
        7: { year: '', item: 'Graduated from Joshibi University of Art and Design' },
        8: { year: '', item: 'Enter the University of Applied Arts Vienna, Painging(Prof. Henning Bohl)' },
        9: { year: '', item: 'Horita Scholarship Foundation Scholarship Student 2017−2019' },
        10: { year: '', item: 'Under the sky (Hohenstaufen studio)' },
        11: { year: '2018', item: 'RAND (Schallautzer Straße /Studio Nita Tando)' },
        12: { year: '', item: 'Group Performance The Art of Sleeping (Vienna, Austria)' },
        13: { year: '', item: 'Exhibition The Butterfly in the Aquarium (Gallery Wolke, Tokyo, Japan)' },
        14: { year: '2019', item: 'Group Exhibition Aus GUTEM HAUSE (Educult in MQ Wien, Vienna, Austria)' },
        15: { year: '', item: 'Group Exhibition  Cute but Creepy (wasserwasser, Vienna, Austria)' },
        16: { year: '2020', item: 'Group Performance Art of Sound (Oskarkokoschka-2, Vienna, Austria)' },
        17: { year: '', item: 'Group Exhibition Cute but Creepy vol.2 (dieschone, Vienna, Austria)' },
        // 18: { year: '', item: 'Exhibition between us (Gallery Wolke, Tokyo, Japan)' },
      },
      exhibition: {
        period: {
          title: 'Session',
          sentense1: '12/7/2020 (Sun.) - 19/7/2020 (Sun.) ※Wednesday is closed',
          sentense2: '10:00−19:00',
        },
        venue: {
          title: 'Venue',
          sentense1: 'Gallery Wolke, Tokyo/Japan (Japanese)',
        },
        info: {
          1: 'between dream and reality',
          2: 'between love and hate',
          3: 'between here and there',
          4: 'between red and purple',
          5: 'between you and me',
        }
      }
    },
    video: {
      venue: 'Exhibition view',
      production: 'Studio view',
    },
  }
}
